import { TrackingPageModel } from '../tracking-page.model';
import {
  getAppImage,
  getAsset,
  getFontConfig,
  getSocialIcons,
  getFooterItems,
  getLogo,
  getLanguageMenu,
  white,
  getProductItems
} from './helpers';

export const bliss: TrackingPageModel = {
  languageMenu: getLanguageMenu('Raleway', '#777777ff'),
  searchPageInput: {
    backgroundColor: white,
    shadow: 'none',
    borderColor: '#ced4da',
    borderWidth: 1,
    borderRadius: 4,
    ...getFontConfig('Raleway', '#6d788c')
  },
  searchPageTitle: {
    fontSize: 18,
    ...getFontConfig('Raleway', '#777777ff')
  },
  background: {
    color: white,
    useBackgroundImage: false,
    imageUrl: getAppImage('/assets/img/tracking-page/Img_map_white.png'),
    backgroundMode: 'cover',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat'
  },
  card: {
    linksColor: '#d14800ff',
    linksUnderline: false,
    backgroundColor: '#FFFFFF',
    headerBackground: '#FFFFFF',
    footerBackground: '#FFFFFF',
    borderColor: '#77777733',
    borderRadius: 2,
    borderWidth: 1,
    shadow: 'none',
    trackingNumberField: 'trackingNumber',
    ...getFontConfig('Raleway', '#777777ff')
  },
  orderCard: {
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#e5e5e5ff',
    backgroundColor: white,
    shadow: 'none',
    footerBackground: white,
    headerBackground: white,
    linksColor: '#d14800ff',
    linksUnderline: false,
    ...getFontConfig('Raleway', '#777777ff')
  },
  orderNumber: {
    alignment: 'center',
    fontSize: 13,
    ...getFontConfig('Raleway', '#777777ff')
  },
  orderStatus: {
    alignment: 'center',
    fontSize: 18,
    ...getFontConfig('Josefin Sans', '#f47900ff')
  },
  orderLastUpdated: {
    alignment: 'center',
    fontSize: 11,
    ...getFontConfig('Raleway', '#777777ff')
  },
  notYetShippedItemsTitle: {
    alignment: 'center',
    fontSize: 11,
    ...getFontConfig('Raleway', '#777777ff')
  },
  orderStatusOn: true,
  orderNumberOn: true,
  orderLastUpdatedOn: true,
  orderItemsFrame: {
    on: true,
    shadow: 'none',
    borderColor: '#d14800ff',
    borderRadius: 4,
    borderWidth: 1,
    backgroundColor: '#ffffff',
    button: {
      on: true,
      backgroundColor: '#ff7100ff',
      borderColor: '#ffffff00',
      borderRadius: 4,
      borderWidth: 1,
      shadow: 'none',
      ...getFontConfig('Josefin Sans', '#ffffffff')
    },
    itemsLimit: 4,
    scroll: false,
    itemCard: {
      backgroundColor: '#ffffff00',
      borderColor: '#ffffffff',
      borderRadius: 4,
      borderWidth: 1,
      shadow: 'none',
      title: {
        alignment: 'left',
        fontSize: 17,
        ...getFontConfig('Josefin Sans', '#000000ff')
      },
      info: {
        alignment: 'left',
        fontSize: 15,
        ...getFontConfig('Raleway', '#777777ff')
      },
      showAttributes: false
    }
  },
  searchButton: {
    on: true,
    backgroundColor: '#00ccff00',
    borderColor: '#d14800ff',
    borderRadius: 2,
    borderWidth: 1,
    shadow: 'none',
    ...getFontConfig('Roboto', '#d14800ff')
  },
  detailsButton: {
    on: null,
    backgroundColor: '#d14800ff',
    borderColor: '#00ccff00',
    borderRadius: 2,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Roboto', white)
  },
  trackButton: {
    on: null,
    backgroundColor: '#d14800ff',
    borderColor: '#ee7227',
    borderRadius: 2,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Roboto', white)
  },
  pageScroll: {
    scrollColor: '#00000033',
    borderRadius: 4,
    backgroundColor: '#ffffff00'
  },
  scripts: {
    head: null,
    body: null
  },
  logo: getLogo(getAsset('/images/themes/5c98e25643d4f_logo-380x.png')),
  socialIcons: getSocialIcons('#e5986fff'),
  sidebar: {
    parcelIcon: 'icon-parcel',
    groupIcon: 'icon-track_number',
    backgroundColor: white,
    borderColor: '#77777733',
    borderRadius: 2,
    borderWidth: 1,
    sidebarField: 'orderNumbers',
    shadow: 'none',
    ...getFontConfig('Raleway', '#777777ff')
  },
  footer: {
    linksColor: '#d14800ff',
    linksUnderline: false,
    backgroundColor: white,
    ...getFontConfig('Raleway', '#777777'),
    ...getFooterItems()
  },
  header: {
    backgroundColor: white
  },
  faviconUrl: '/assets/favicon/favicon-32x32.png',
  sidebarProductsFeed: {
    on: true,
    backgroundColor: '#FFFFFF',
    borderColor: '#77777733',
    borderRadius: 2,
    borderWidth: 1,
    shadow: 'none',
    card: {
      backgroundColor: '#FFFFFF',
      borderColor: '#77777733',
      borderRadius: 2,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#d14800ff',
        borderColor: '#00ccff00',
        borderRadius: 2,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Josefin Sans', white)
      },
      buttonText: 'BUY NOW',
      title: {
        alignment: 'center',
        fontSize: 20,
        ...getFontConfig('Josefin Sans', '#000000ff')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 13,
        ...getFontConfig('Raleway', '#919191ff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 20,
        ...getFontConfig('Raleway', '#329225ff')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('sidebar'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#d14800ff',
      arrowSize: 24
    }
  },
  mainProductsFeed: {
    on: true,
    backgroundColor: '#FFFFFF',
    borderColor: '#77777733',
    borderRadius: 2,
    borderWidth: 1,
    shadow: 'none',
    card: {
      backgroundColor: '#FFFFFF',
      borderColor: '#77777733',
      borderRadius: 2,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#d14800ff',
        borderColor: '#00ccff00',
        borderRadius: 2,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Josefin Sans', white)
      },
      buttonText: 'BUY NOW',
      title: {
        alignment: 'center',
        fontSize: 16,
        ...getFontConfig('Josefin Sans', '#000000ff')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Raleway', '#d14800ff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 17,
        ...getFontConfig('Raleway', '#24952eff')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('main'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#d14800ff',
      arrowSize: 24
    }
  },
  seoTitle: ''
};
